<template>
  <v-dialog v-model="isVisible" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary">
        Repeat Event
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Repeat event
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" dense outlined>
          It will repeat until the end of this year
        </v-alert>
        <v-select
          single-line
          item-text="title"
          :items="select"
          label="Repetitions"
          item-value="value"
          return-object
          v-model="repeatChoice"
          @change="calculateDates"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="close">
          Cancel
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!repeatChoice">
          <v-icon dark>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["event"],
  data: () => ({
    isVisible: false,
    repeatChoice: null,
    dates: [],
    select: [
      { value: 1, title: "Weekly" },
      { value: 2, title: "Every 2 weeks" },
      { value: 3, title: "Every 3 weeks" },
      { value: 4, title: "Every 4 weeks" }
    ]
  }),
  methods: {
    calculateDates() {
      let currentYear = this.$moment().year();
      let lastDayOfCurrentYear = this.$moment(
        currentYear.toString() + "-12-31"
      );
      let selectedDate = this.$moment(this.event.date);
      selectedDate.add(this.repeatChoice.value, "week");
      while (selectedDate < lastDayOfCurrentYear) {
        this.dates.push(
          `${selectedDate.format("YYYY-MM-DD")} ${this.event.startTime}`
        );
        selectedDate.add(this.repeatChoice.value, "week");
      }
    },
    close() {
      this.repeatChoice = null;
      this.isVisible = false;
    },
    save() {
      this.$emit("saveRepetitions", this.dates);
      this.close();
    }
  },
  computed: {}
};
</script>

<style></style>
